"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.fromJSONPrimitiveAttr = void 0;
const index_js_1 = require("../../../../attributes/binary/index.js");
const index_js_2 = require("../../../../attributes/boolean/index.js");
const index_js_3 = require("../../../../attributes/null/index.js");
const index_js_4 = require("../../../../attributes/number/index.js");
const index_js_5 = require("../../../../attributes/string/index.js");
const isString_js_1 = require("../../../../utils/validation/isString.js");
const charCodeAt0 = (str) => str.charCodeAt(0);
/**
 * @debt feature "handle defaults, links & validators"
 */
const fromJSONPrimitiveAttr = (attr) => {
    switch (attr.type) {
        case 'null': {
            const { links, defaults, ...props } = attr;
            links;
            defaults;
            const $attr = (0, index_js_3.nul)(props);
            return $attr;
        }
        case 'boolean': {
            const { links, defaults, enum: _enum, ...props } = attr;
            links;
            defaults;
            const $attr = (0, index_js_2.boolean)(props);
            return _enum ? $attr.enum(..._enum) : $attr;
        }
        case 'number': {
            const { links, defaults, enum: _enum, ...props } = attr;
            links;
            defaults;
            const $attr = (0, index_js_4.number)(props);
            return _enum
                ? $attr.enum(..._enum.map(value => ((0, isString_js_1.isString)(value) ? BigInt(value) : value)))
                : $attr;
        }
        case 'string': {
            const { links, defaults, enum: _enum, transform, ...props } = attr;
            links;
            defaults;
            transform;
            const $attr = (0, index_js_5.string)(props);
            return _enum ? $attr.enum(..._enum) : $attr;
        }
        case 'binary': {
            const { links, defaults, enum: _enum, ...props } = attr;
            links;
            defaults;
            const $attr = (0, index_js_1.binary)(props);
            if (!_enum) {
                return $attr;
            }
            return $attr.enum(..._enum.map(value => new Uint8Array(atob(value).split('').map(charCodeAt0))));
        }
    }
};
exports.fromJSONPrimitiveAttr = fromJSONPrimitiveAttr;
